import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CheckCircle2 } from "lucide-react";
import serviceShingles from "@/assets/service-shingles-east-end.jpg";
import serviceFlatRoof from "@/assets/service-flat-roof-east-end.jpg";
import serviceSpecialty from "@/assets/service-specialty-cedar.jpg";
import serviceRepair from "@/assets/service-roof-repair.jpg";

const services = [
  {
    key: "shingles",
    label: "Asphalt Shingles",
    title: "Premium Asphalt Shingle Roofing",
    description: "We install GAF Timberline UHDZ and HDZ — America's #1 selling shingles — backed by a 50-year limited lifetime warranty. Available in 20+ colors to match your home.",
    features: ["Class A fire rating", "130 MPH wind warranty", "StainGuard Plus™ protection", "LayerLock™ technology"],
    image: serviceShingles,
  },
  {
    key: "flat",
    label: "Flat Roofing",
    title: "Commercial & Residential Flat Roofing",
    description: "Expert TPO, EPDM, and modified bitumen flat roof installations with superior waterproofing. Ideal for extensions, garages, and commercial buildings.",
    features: ["Energy-efficient white TPO", "20-year warranties available", "Seamless membrane systems", "Expert drainage solutions"],
    image: serviceFlatRoof,
  },
  {
    key: "repair",
    label: "Roof Repair",
    title: "Fast, Reliable Roof Repairs",
    description: "From emergency storm damage to slow leaks, our repair team responds quickly to protect your home. Same-day service available.",
    features: ["Emergency 24/7 response", "Insurance claim assistance", "Leak detection technology", "Permanent repair solutions"],
    image: serviceRepair,
  },
  {
    key: "specialty",
    label: "Specialty Roofing",
    title: "Specialty Roofing Systems",
    description: "Premium roofing options for homeowners who want a distinctive look or longer lifespan — including cedar shake, standing seam metal, clay/concrete tile, and natural slate. Each system is installed by crews specifically trained for that material.",
    features: ["Cedar shake & shingle roofing", "Standing seam metal roofing", "Clay & concrete tile roofing", "Natural & synthetic slate"],
    image: serviceSpecialty,
  },
];

export const AdsServicesTabs = () => (
  <section className="py-16 bg-background">
    <div className="container mx-auto px-4">
      <h2 className="text-3xl font-extrabold text-center text-foreground mb-2">
        Our <span className="text-primary">Roofing Services</span>
      </h2>
      <p className="text-center text-muted-foreground mb-10">
        Full-service roofing solutions for Long Island homes and businesses.
      </p>

      <Tabs defaultValue="shingles" className="max-w-3xl mx-auto">
        <TabsList className="w-full grid grid-cols-2 md:grid-cols-4 h-auto">
          {services.map((s) => (
            <TabsTrigger key={s.key} value={s.key} className="text-xs md:text-sm py-2.5">
              {s.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {services.map((s) => (
          <TabsContent key={s.key} value={s.key} className="mt-8">
            <div className="bg-muted rounded-2xl overflow-hidden">
              {s.image && (
                <img src={s.image} alt={s.title} className="w-full h-56 object-cover" />
              )}
              <div className="px-5 md:px-8 pt-6 pb-6 md:pb-8">
                <h3 className="text-2xl font-bold text-foreground mb-3">{s.title}</h3>
                <p className="text-muted-foreground mb-6">{s.description}</p>
                <ul className="grid sm:grid-cols-2 gap-3">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-2">
                      <CheckCircle2 className="w-4 h-4 text-primary shrink-0" />
                      <span className="text-foreground text-sm">{f}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  </section>
);
